import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/_consumer/receipts/$receiptId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/activity',
      search: { receipt: params.receiptId },
    });
  },
});
